/* eslint-disable @typescript-eslint/ban-ts-comment */
import { type Attribute, Node } from "@tiptap/core";
import ImageNodeView from "./components/ImageNodeView";
import { DEFAULT_ATTRIBUTES, EXTENSION_NAME } from "./constants";
import type { ImageAttributes } from "./type";

export const Image = /* @__PURE__ */ Node.create({
  name: EXTENSION_NAME,
  content: "",
  marks: "",
  group: "block",
  selectable: true,
  atom: true,
  draggable: true,

  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        class: "image",
      },
      userId: null,
    };
  },

  addAttributes() {
    return {
      width: {
        default: DEFAULT_ATTRIBUTES.width,
      },
      src: {
        default: DEFAULT_ATTRIBUTES.src,
      },
      maxWidth: {
        default: null,
      },
      minWidth: {
        default: null,
      },
      aspectRatio: {
        default: null,
      },
      frameborder: {
        default: DEFAULT_ATTRIBUTES.frameborder,
      },
      allowfullscreen: {
        default: DEFAULT_ATTRIBUTES.allowfullscreen,
      },
      alt: {
        default: DEFAULT_ATTRIBUTES.alt,
      },
      id: {
        default: null,
      },
      placeholder: {
        default: null,
      },
      caption: {
        default: DEFAULT_ATTRIBUTES.caption,
      },
      align: {
        default: DEFAULT_ATTRIBUTES.align,
      },
    } as Record<keyof ImageAttributes, Attribute>;
  },
});

export const ImageNodeMapping = {
  [EXTENSION_NAME]: ImageNodeView,
};
